// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const ChevronRight: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 28 28"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="24"
            height="24"
            fill="currentColor"
        >
            <path d="M14 0c7.7 0 14 6.3 14 14s-6.3 14-14 14S0 21.7 0 14 6.3 0 14 0zm0 26.5c6.9 0 12.5-5.6 12.5-12.5S20.9 1.5 14 1.5 1.5 7.1 1.5 14 7.1 26.5 14 26.5z" />
            <path fillRule="evenodd" d="M10.6 8.6l5.5 5.3-5.5 5.4 1.7 1.6 7.1-7-7.1-7z" clipRule="evenodd" />
        </svg>
    );
};

export default React.memo(ChevronRight);
